import React, { useState, useEffect, useRef } from 'react';
import { Button, Form,Input, Col, Row, Card, Divider, Modal, Select, Upload } from 'antd';
import { getData, createDataUnAuth, patchDataUnAuth } from '../../../util/API';
import { message } from "antd/lib/index";
import CircularProgress from "components/CircularProgress/index";


const updateData = (data) => {
    let count = 0
    for (let item of data) {
        item['key'] = count;
        item['value'] = item.value?item.value:""
        count += 1
    }
    return data;
}


function error(content) {
    Modal.error({
        title: 'Error!',
        content: content,
    });
}

function warning() {
    Modal.warning({
        title: 'Warning!',
        content: 'Duration of work is more than 1 hour!.Confirm before submitting the CSO form! ',
    });
}

const { TextArea } = Input;
const { Dragger } = Upload;

const USDForm = (props) => {
    const [loading, setLoading] = useState(false);
    const [url_check, setURLCheck] = useState(false);
    const [ticket_id, setTicketID] = useState(null);
    const [error_msg, setMessage] = useState("");
    const [dataSource, setDataKey] = useState([]);





    useEffect(() => {
        const { ticket_id, project_id } = props.match.params
        setTicketID(ticket_id)
        checkUrl(project_id)
    }, []);

    const onDataValueChange = (key, value) => {
        // console.log(value,key,'dddddrrrrrrrr')
        let newData = [...dataSource]
        newData[key].value = value
        setDataKey(newData)
    }



    const checkUrl = (project_id) => {
        // console.log(url_id, ticket_id)
        let endpoint = `/management/unstructured-template/?project=${project_id}`;
        let part = []
        getData(endpoint)
            .then(res => {
                if (res.data.results) {
                    // console.log(res.data.results[0].data, 'd')
                    setDataKey(updateData(res.data.results[res.data.count-1].data))
                    // let temp = res.data.results[0].data.map((x,index) =>
                    //     <Col lg={12} md={24} sm={24} xs={24}  >
                    //         <Form.Item label={x.keys} {...formItemLayout}>
                    //             {getFieldDecorator(x.keys, {
                    //                 // initialValue: slno,
                    //                 rules: [{ required: x.is_optional === false ? true : false, message: 'Please fill the field!' }],
                    //             })(
                    //                 <Select
                    //                 // defaultValue={['cni','pni']}
                    //                 value={x.value}
                    //                 mode="tags"
                    //                 placeholder="Enter Values"
                    //                 style={{ width: '100%' }}
                    //                 onChange={onDataValueChange.bind(this, index)}
                    //             >
            
                    //             </Select>
                    //             )}
                    //         </Form.Item>
                    //     </Col>
                    // )
                    // console.log(temp, 'teee')
                    // setPreFillData(temp)
                    setURLCheck(true)
                }
                else {
                    setMessage(res.data.message)
                    setURLCheck(false)
                }

            }).catch(error => {
                message.error('Error Checking Link!', error)
                setMessage("Error Validating Link!")
                setURLCheck(true)
            });
    }



    const handleFormSubmit = e => {
        setLoading(true)
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let endpoint = '/management/unstructured-update-by-template/'
                const data={
                    ticket:ticket_id,
                    data:dataSource
                }

                createDataUnAuth(endpoint,data)
                    .then(res => {
                        if (res.data.status === 200) {
                            message.success(res.data.message)
                            setLoading(false)
                            props.history.push('/success')
                            //   clickNext()

                        }
                        else {
                            setLoading(false)
                            message.error(res.data.message)
                        }
                    }).catch(error => {
                        message.error("Error Saving Form Data! ")
                        // console.log(error)
                        setLoading(false)
                    });
            } else {
                setLoading(false)
            }
        });
    }



    const { getFieldDecorator } = props.form;
    const formItemLayout = {
        labelCol: { xs: 24, sm: 8 },
        wrapperCol: { xs: 24, sm: 16 },
    };
    const formItemLayout2 = {
        labelCol: { xs: 24, sm: 12 },
        wrapperCol: { xs: 24, sm: 12 },
    };


    const toUpperCase = e => {
        e.target.value = e.target.value.toUpperCase()

    }


    return (

        url_check ? <Card className='gx-card' title="" style={{ width: "100%", height: "100%", overflow: "auto" }} >
            {loading &&
                <div className="gx-loader-view gx-loader-position">
                    <CircularProgress />
                </div>
            }
            <Card  >
                <Row>

                    <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: "center" }} >
                        <img src="/favicon-96x96.png" ></img>
                    </Col>
                    {/* <Col lg={12} md={24} sm={24} xs={24} style={{ textAlign: "center" }}>
                        <Avatar size={64} src="/hp.png" />
                    </Col> */}
                    <Col lg={8} md={24} sm={24} xs={24}  >

                    </Col>
                    <Col lg={8} md={24} sm={24} xs={24}  >
                        <Divider orientation="center" style={{ fontSize: 24 }}>Unstructured Data Form</Divider>
                        <br></br>
                        <br></br>
                    </Col>
                    <Col lg={8} md={24} sm={24} xs={24}  >
                    </Col>
                </Row>

                <Form  {...formItemLayout} onSubmit={handleFormSubmit} >
                    <Row>

                        {dataSource.map((x,index) =>
                        <Col lg={12} md={24} sm={24} xs={24}  >
                            <Form.Item label={x.keys} {...formItemLayout}>
                                {getFieldDecorator(x.keys, {
                                    // initialValue: slno,
                                    rules: [{ required: x.is_optional === false ? true : false, message: 'Please fill the field!' }],
                                })(
                                    <Select
                                    // defaultValue={['cni','pni']}
                                    value={x.value}
                                    mode="tags"
                                    placeholder="Enter Values"
                                    style={{ width: '100%' }}
                                    onChange={onDataValueChange.bind(this, index)}
                                >
            
                                </Select>
                                )}
                            </Form.Item>
                        </Col>
                    )}
                        <Col lg={24} md={24} sm={24} xs={24}  >
                            {/* <Button onClick={handleBack} type='primary' icon="left" style={{ float: "left" }}>
                                    Back
                                </Button> */}
                            <Button onClick={handleFormSubmit} type='primary' style={{ float: "right" }} loading={loading}>
                                Save
                            </Button>

                        </Col>
                    </Row>
                </Form>
            </Card>
        </Card> :
            <Card className='gx-card'>
                <Row>
                    <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: "center" }} >
                        <h2 style={{ color: "red" }}>{error_msg}</h2>
                    </Col>
                </Row>
            </Card>
    )
}

export default Form.create()(USDForm);